import { OnInit, Component, ViewEncapsulation, ViewChild } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';
import { ValidatorService } from 'app/shared/services/validator.service';
import { IResult } from 'app/shared/models/result.model';
import { Subject, Observable } from 'rxjs';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AppConfig } from 'app/app.config';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { IDtoRiskPremium } from 'app/shared/models/organization/dto-risk-premium.model';
import { IDtoPlan } from 'app/shared/models/customer/dto-plan.model';
import { IDtoCatalog } from 'app/shared/models/dto-catalog.model';
import { CustomerService } from 'app/views/appviews/quote/customer.service';
import { IDtoModuleLog } from 'app/shared/models/security/dto-module-log.model';
import { IdentityService } from 'app/views/appviews/security/identity.service';

@Component({
    selector: 'app-modal-plan',
    styleUrls: ['./modal-plan.style.scss'],
    templateUrl: './modal-plan.template.html',
    encapsulation: ViewEncapsulation.None
})

export class ModalPlanComponet implements OnInit {
    /**Validadores */
    private validator = ValidatorService;
    private fsaFlags = [false];
    private errorMessages: any;
    /**Formularios */
    private formPlan: FormGroup;
    /**Variable de trasporte de datos */
    private result: IResult;
    /**Retorno a pantalla padre */
    public onClose: Subject<any>;
    /**Variables */
    private projectCustomerId?: number;
    private plan: IDtoPlan;
    private action = 'add';
    /**Listas */
    private plans = new Array() as IDtoPlan[];
    /**Catalogos */
    private catalogCategories: Observable<IDtoCatalog[]>;
    /** Tablas*/
    @ViewChild(DatatableComponent, { static: false }) tablePlans: DatatableComponent;
    constructor(private bsModalRef: BsModalRef
        , private formBuilder: FormBuilder
        , private customerService: CustomerService
        , private configGeneral: AppConfig
        , private identityService: IdentityService) {
        this.initializeFormRiskPremium();
    }
    ngOnInit(): void {
        this.catalogCategories = this.customerService.getCatalogCategories();
        this.onClose = new Subject();
    }
    private initializeFormRiskPremium() {
        this.formPlan = this.formBuilder.group({
            codeNom: [null, []],
            name: [null, [Validators.required, Validators.maxLength(255)]],
            categoryId: [null, [Validators.required]],
            description: [null, [Validators.maxLength(255)]],
            isActive: [null, [Validators.required]],
        });
    }
    private submit(): void {
        if (this.formPlan.valid) {
            if (this.action === 'add') {
                this.save();
            } else {
                this.update();
            }
        } else {
            this.configGeneral.newToast('Validación', 'Capture toda la información requerida para poder continuar', 'warning');
            this.configGeneral.touchedControls(this.formPlan);
        }
    }
    private save(): void {
        const dto = this.formPlan.value as IDtoPlan;
        dto.projectCustomerId = this.projectCustomerId;
        this.customerService.addPlan(dto)
            .subscribe(
                (x) => {
                    if (this.configGeneral.notificationSuccessError(x)) {
                        let p = x.data as IDtoPlan;
                        this.addModuleLog(p.id, 'new');
                        this.plans.push(p);
                        this.onClose.next(this.plans);
                        this.bsModalRef.hide();
                    }
                },
                (errMessage) => this.errorMessages = errMessage.messages);
    }
    private update(): void {
        const dto = this.formPlan.value as IDtoPlan;
        dto.projectCustomerId = this.plan.projectCustomerId;
        dto.id = this.plan.id;
        this.customerService.updatePlan(dto)
            .subscribe(
                (x) => {
                    if (this.configGeneral.notificationSuccessError(x)) {
                        let index = this.plans.indexOf(this.plan)
                        if (index > -1) {
                            this.plans.splice(index, 1);
                            this.plans.push(dto);
                            this.onClose.next(this.plans);
                            this.bsModalRef.hide();
                        }
                        this.addModuleLog(dto.id, 'update');
                    }
                },
                (errMessage) => this.errorMessages = errMessage.messages);
    }
    private onCancel(): void {
        this.bsModalRef.hide();
    }
    private selectRow(item: IDtoPlan): void {
        this.plan = item;
        this.formPlan.patchValue(this.plan);
        this.action = 'edit';
    }
    private resetForm(): void {
        this.formPlan.reset();
        this.action = 'add';
    }
    private addModuleLog(id: number, action: string): void {
        let dto = {} as IDtoModuleLog;
        dto.table = 'PlanTrademarks';
        dto.module = 'projects';
        dto.action = action;
        dto.registryAffectedId = id;
        this.identityService.addModuleLog(dto).subscribe(
            (x) => { });
    }
}
